import { useEffect, useState } from "react";
import { Zap } from "lucide-react";

const timeLeft = (endsAt) => {
  const ms = new Date(endsAt) - Date.now();
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return `${h}h ${m}m`;
};

export const SaleBanner = ({ endsAt, percentOff }) => {
  const [left, setLeft] = useState(() => timeLeft(endsAt));

  useEffect(() => {
    const id = setInterval(() => setLeft(timeLeft(endsAt)), 30000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (!left) return null;

  return (
    <div
      className="mx-auto flex w-fit items-center gap-2 rounded-full border border-[#2f7fff]/50 bg-[#2f7fff]/15 px-5 py-2.5 text-sm font-semibold text-white"
      data-testid="sale-banner"
    >
      <Zap className="h-4 w-4 text-[#2f7fff]" />
      FLASH SALE — {percentOff}% OFF EVERYTHING
      <span className="text-zinc-300 font-normal">· ends in {left}</span>
    </div>
  );
};
